import loadable from '@loadable/component';

const LoadingLoadable = loadable(() => import(/* webpackChunkName: "loading-page" */ './index'));

export default LoadingLoadable;
